// LegalProfessionals.jsx
import React, { useState, useEffect } from "react";
import "./professionals.css";
import Header from "../components/header";
import SearchIcon from "./assets/icon-search.png";
import OptionsIcon from "./assets/optionsIcon.png";
import { useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import AddProfessionalForm from "./addProfessionalForm";
import IconCheckbox from "../../components/input/new/iconCheckbox";

const LegalProfessionals = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [professionals, setProfessionals] = useState([]);
  const [filteredProfessionals, setFilteredProfessionals] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]); // the “live” filters
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  // temp state while the menu is open:
  const [tempSelectedRoles, setTempSelectedRoles] = useState([]);
  const [tempSelectedStatuses, setTempSelectedStatuses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [inviteError, setInviteError] = useState(null);

  // anchor for the Role‐filter menu
  const [roleAnchorEl, setRoleAnchorEl] = useState(null);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);

  const firmId = useSelector((state) => state.firm.details?.id);

  const profileTypes = [
    { label: "Legal Professionals", value: "legal" },
    { label: "Practice Support Specialists", value: "support" },
  ];

  // fetch on mount
  useEffect(() => {
    const fetchProfessionals = async () => {
      try {
        const res = await fetch(
          `/api/attorney/fetchFirmMembers?firm_id=${firmId}`
        );
        const data = await res.json();
        if (res.ok) {
          setProfessionals(data.lawyers);
          setFilteredProfessionals(data.lawyers);
        } else {
          setInviteError("Failed to load professionals.");
        }
      } catch {
        setInviteError("Failed to load professionals.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchProfessionals();
  }, [firmId]);

  const formatDate = (ts) =>
    ts
      ? new Date(ts).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })
      : "N/A";

  // inline add form handlers
  const handleAddClick = () => setIsAdding(true);
  const handleCancelAdd = () => setIsAdding(false);
  const handleSaveNew = () => setIsAdding(false);

  // your existing filter helpers
  useEffect(() => {
    let result = professionals;

    if (selectedRoles.length) {
      result = result.filter((p) => selectedRoles.includes(p.role));
    }
    if (selectedStatuses.length) {
      result = result.filter((p) => selectedStatuses.includes(p.status));
    }
    if (searchName) {
      result = result.filter((p) =>
        p.name.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    setFilteredProfessionals(result);
  }, [professionals, selectedRoles, selectedStatuses, searchName]);
  // per-row menu (you already had this)
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuClick = (e) => setAnchorEl(e.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const menuStyles = {
    paper: {
      borderRadius: 8,
      minWidth: 200,
      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
      padding: "20px",
    },
    item: {
      padding: "12px 16px",
      fontFamily: "Poppins",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "100%",
      letterSpacing: "-0.17px",
      color: "#333333",
    },
  };

  // open / close Role menu
  const handleRoleClick = (e) => setRoleAnchorEl(e.currentTarget);
  const handleRoleClose = () => setRoleAnchorEl(null);
  const handleStatusClick = (e) => setStatusAnchorEl(e.currentTarget);
  const handleStatusClose = () => setStatusAnchorEl(null);

  return (
    <>
      <Header />
      <div className="page-container">
        {isAdding ? (
          <AddProfessionalForm
            onCancel={handleCancelAdd}
            onSave={handleSaveNew}
          />
        ) : (
          <>
            <div className="professionals-header">
              <h1 className="professionals-page-title">Legal professionals</h1>
              <button className="btn-add" onClick={handleAddClick}>
                Add
              </button>
            </div>

            {/* Search & filters */}
            <div className="professionals-search-div">
              <div className="professionals-search__field">
                <img
                  src={SearchIcon}
                  alt="Search"
                  className="professionals__search__icon"
                />
                <input
                  type="text"
                  placeholder="Search by name, keyword..."
                  className="professionals_search__input"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                />
              </div>

              {/* Role filter button */}
              <button
                className="professionals-filter-buttons"
                onClick={(e) => {
                  setTempSelectedRoles(selectedRoles);
                  setRoleAnchorEl(e.currentTarget);
                }}
              >
                Role
              </button>
              <Menu
                anchorEl={roleAnchorEl}
                open={Boolean(roleAnchorEl)}
                onClose={handleRoleClose}
                PaperProps={{ style: menuStyles.paper }}
              >
                <div className="filter-menu">
                  {/* {["Legal Professional", "Practice Support Specialist"].map(
                    (role) => (
                      <IconCheckbox
                        key={role}
                        label={role}
                        checked={tempSelectedRoles.includes(role)}
                        onChange={(checked) => {
                          setTempSelectedRoles((prev) =>
                            checked
                              ? [...prev, role]
                              : prev.filter((r) => r !== role)
                          );
                        }}
                      />
                    )
                  )} */}

                  {profileTypes.map(({ label, value }) => (
                    <IconCheckbox
                      key={value}
                      label={label}
                      checked={tempSelectedRoles.includes(value)}
                      onChange={(checked) =>
                        setTempSelectedRoles((prev) =>
                          checked
                            ? [...prev, value]
                            : prev.filter((v) => v !== value)
                        )
                      }
                    />
                  ))}

                  <div className="filter-menu-actions">
                    <button
                      className="filter-clear"
                      disabled={tempSelectedRoles.length === 0}
                      onClick={() => setTempSelectedRoles([])}
                    >
                      Clear
                    </button>
                    <button
                      className="filter-apply"
                      onClick={() => {
                        setSelectedRoles(tempSelectedRoles);
                        handleRoleClose();
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </Menu>

              {/* Status filter */}
              <button
                className="professionals-filter-buttons"
                onClick={(e) => {
                  setTempSelectedStatuses(selectedStatuses);
                  setStatusAnchorEl(e.currentTarget);
                }}
              >
                Status
              </button>
              <Menu
                anchorEl={statusAnchorEl}
                open={Boolean(statusAnchorEl)}
                onClose={handleStatusClose}
                PaperProps={{ style: menuStyles.paper }}
              >
                <div className="filter-menu">
                  {["Active", "Pending"].map((status) => (
                    <IconCheckbox
                      key={status}
                      label={status}
                      checked={tempSelectedStatuses.includes(status)}
                      onChange={(checked) => {
                        setTempSelectedStatuses((prev) =>
                          checked
                            ? [...prev, status]
                            : prev.filter((s) => s !== status)
                        );
                      }}
                    />
                  ))}

                  <div className="filter-menu-actions">
                    <button
                      className="filter-clear"
                      disabled={tempSelectedStatuses.length === 0}
                      onClick={() => setTempSelectedStatuses([])}
                    >
                      Clear
                    </button>
                    <button
                      className="filter-apply"
                      onClick={() => {
                        setSelectedStatuses(tempSelectedStatuses);
                        handleStatusClose();
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </Menu>

              {/* Status filter */}
              {/* <button
                className="professionals-filter-buttons"
                onClick={() => filterByStatus(selectedStatus ? "" : "Active")}
              >
                Status {selectedStatus ? `: ${selectedStatus}` : ""}
              </button> */}
            </div>

            {inviteError && <div className="error-message">{inviteError}</div>}

            {/* List */}
            {!isLoading && filteredProfessionals.length > 0 ? (
              <div className="professionals-list">
                {/* header row */}
                <div className="professionals-table-header">
                  <p className="professionals-table-titles">Name</p>
                  <p className="professionals-table-titles">Status</p>
                  <p className="professionals-table-titles">Phone Number</p>
                  <p className="professionals-table-titles">Search Score</p>
                  <p className="professionals-table-titles">Date Added</p>
                  <p className="professionals-table-titles" />
                </div>

                {filteredProfessionals
                  .filter((p) =>
                    p.name.toLowerCase().includes(searchName.toLowerCase())
                  )
                  .map((p, idx) => (
                    <div key={idx} className="professionals-table-row">
                      <div className="professionals-table-info">
                        <img
                          src={p.profile_photo_url}
                          alt=""
                          className="professional-table-photo"
                          loading="lazy"
                        />
                        <div className="professionals-table-vertical">
                          <div className="professionals-table-name">
                            {p.name}
                          </div>
                          <div className="professionals-table-role">
                            {p.role}
                          </div>
                        </div>
                      </div>
                      <div className="professionals-table-content">
                        {p.status}
                      </div>
                      <div className="professionals-table-content">
                        {p.phone_number}
                      </div>
                      <div className="professionals-table-content">N/A</div>
                      <div className="professionals-table-content">
                        {formatDate(p.created_at)}
                      </div>
                      <div className="professionals-table-content">
                        <IconButton onClick={handleMenuClick}>
                          <img
                            src={OptionsIcon}
                            style={{ width: 24, height: 24 }}
                            alt="options"
                          />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleCloseMenu}
                          PaperProps={{ style: menuStyles.paper }}
                        >
                          {[
                            "Resend invitation",
                            "Edit",
                            "Make admin",
                            "Onboard user",
                            "Delete",
                          ].map((opt) => (
                            <MenuItem key={opt} style={menuStyles.item}>
                              {opt}
                            </MenuItem>
                          ))}
                        </Menu>
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <p className="empty-message">
                You haven't added any legal professionals yet...
              </p>
            )}

            <div className="help-section">
              <a href="#">Need help?</a>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LegalProfessionals;
